import React from 'react';
import { inject, observer} from 'mobx-react';
import {Button, Steps, Spin, Tabs, Modal,message} from 'antd';
const confirm = Modal.confirm;
const TabPane = Tabs.TabPane;
const Step = Steps.Step;
import {WeaDialog, WeaSearchGroup, WeaTools, WeaTableEdit, WeaNewScroll, WeaFormItem,WeaAlertPage,WeaTab} from 'ecCom';
import {WeaSwitch} from 'comsMobx'
import UploadAvatar from '../../../../pc4public/hrm/uploadAvatar'
import InputBtn from '../../coms/inputBtn'
import forEach from 'lodash/forEach'
import isEmpty from 'lodash/isEmpty'
const getKey = WeaTools.getKey;
import * as mobx from 'mobx';
const toJS = mobx.toJS;
import {i18n} from '../../public/i18n';

@inject('hrmAdd')

@observer
class Full extends React.Component {
    constructor(props) {
        super(props);
        const funcs = ['pre', 'next', 'save', 'more', 'onTabChange', 'tableEditChange'];
        funcs.forEach(f=> this[f] = this[f].bind(this));
    }

    componentWillReceiveProps(nextProps) {
        const { hrmAdd } = this.props;
        if ('visible' in this.props && this.props.visible !== nextProps.visible) {
            if (nextProps.visible) {
                hrmAdd.current = 0;
                hrmAdd.canSave = true;
                hrmAdd.getHrmResourceAddForm();
            }
        }
    }

    componentDidMount(){
        const dom = $('<Object id="htactx" name="htactx" classid="clsid:FB4EE423-43A4-4AA9-BDE9-4335A6D3C74E" codebase="HTActX.cab#version=1,0,0,1" style="HEIGHT: 0px; WIDTH: 0px"></Object>');
        $(document.body).append(dom);
        // const {hrmAdd} = this.props;
        // const {current} = hrmAdd;
        // hrmAdd.current = 1;
    }

    pre() {
        const {hrmAdd} = this.props;
        const {current} = hrmAdd;
        this.refs.scrollBar.scrollerToTop();
        hrmAdd.current = current - 1;
    }

    next() {
        const {hrmAdd} = this.props;
        const {current} = hrmAdd;
        hrmAdd.myvalidate(()=> {
            this.refs.scrollBar.scrollerToTop();
            hrmAdd.current = current + 1;
        })
    }

    save(){
        const {hrmAdd} = this.props;
        hrmAdd.saveFull();
    }

    onTabChange(key){
        const {hrmAdd} = this.props;
        hrmAdd.onTabChange(key);
    }

    tableEditChange(data){
        const {hrmAdd} = this.props;
        hrmAdd.tableEditChange(data);
    }

    more() {

    }

    getBtns() {
        const {hrmAdd} = this.props;
        const {current,canSave} = hrmAdd;
        let btns = [];
        const pre = <Button type="primary" disabled={!canSave} onClick={this.pre} >{i18n.button.lastStep()}</Button>;
        const next = <Button type="primary" disabled={!canSave} onClick={this.next} >{i18n.button.nextStep()}</Button>;
        const ok = <Button type="primary" disabled={!canSave}  onClick={this.save} >{i18n.button.done()}</Button>;
        if (current == 0) {
            btns = [next];
        } else if (current == 3){
            btns = [pre, ok];
        } else {
            btns = [pre, next];
        }
        return btns;
    }

    getSearchs(current){
        const {hrmAdd} = this.props;
        const {formFull,conditionInfo0, conditionInfo1, conditionInfo2, conditionInfo3} = hrmAdd;
        const {isFormInit} = formFull;
        const formParams = formFull.getFormParams();
        let group = [];
        let target;
        if (current < 1) target = conditionInfo0;
        if (current === 1) target = conditionInfo1;
        if (current === 2) target = conditionInfo2;
        if (current === 3) target = conditionInfo3;
        window.e9HideFormFieldKeys = [];
        isFormInit && target && target.forEach(c =>{
            let items = [];
            c.items.forEach( field => {
                let hide = false;
                let hideLabel = false;
                if (formParams.accounttype == '1' && (field.domkey[0] == 'loginid' || field.domkey[0] == 'password' || field.domkey[0] == 'password1' || field.domkey[0] == 'userUsbType') ) hide = true;
                if ((!formParams.userUsbType || formParams.userUsbType == '') && (field.domkey[0] == 'tokenKey' || field.domkey[0] == 'serial' || field.domkey[0] == 'usbstate')) hide = true;
                if (formParams.userUsbType == '4' && (field.domkey[0] == 'tokenKey' || field.domkey[0] == 'serial')) hide = true;
                if (formParams.userUsbType == '2' && field.domkey[0] == 'tokenKey') hide = true;
                if (formParams.userUsbType == '3' && field.domkey[0] == 'serial') hide = true;
                if ((!formParams.accounttype || formParams.accounttype == '0') && field.domkey[0] == 'belongto') hide = true;
                if (field.domkey[0] == 'usbstate') {
                    hideLabel = true;
                }
                let dom;
                if (field.conditionType == 'RESOURCEIMG') {
                    const key = getKey(field);
                    const bindObj = formFull.$(key);
                    dom = <UploadAvatar {...bindObj.bind()}/>
                } else if (field.domkey[0] == 'tokenKey') {
                    const key = getKey(field);
                    const bindObj = formFull.$(key);
                    dom = <InputBtn btnText={i18n.label.binding()} {...bindObj.bind()} onBtnClick={(v)=>hrmAdd.updateKey()}/>
                } else if (field.domkey[0] == 'serial') {
                    const key = getKey(field);
                    const bindObj = formFull.$(key);
                    dom = <InputBtn btnText={i18n.label.binding()} {...bindObj.bind()} onBtnClick={(v)=>hrmAdd.updateKey()}/>
                } else {
                    dom =  <WeaSwitch fieldConfig={field} form={formFull} formParams={formParams}
                    onChange={(v)=> {
                        if (field.domkey[0]=='companystartdate' || field.domkey[0]=='workstartdate') {
                          let value = 0.00;
                          let obj = {};
                          let domKey = '';
  
                          if (field.domkey[0]=='companystartdate') {
                            domKey = 'companyworkyear';
                          }else if(field.domkey[0]=='workstartdate'){
                            domKey = 'workyear';
                          }
                          value = hrmAdd.calYear(v[field.domkey[0]].value);
                          obj[domKey]={value};
                          formFull.updateFields(obj);
                        }
                      }}
                    />;
                }
                if(c.hide || !isEmpty(field.otherParams) && field.otherParams.hide){
                    window.e9HideFormFieldKeys.push(field.domkey[0]);
                }else{
                    items.push({
                        com:<WeaFormItem
                            hideLabel={hideLabel}
                            label={`${field.label}`}
                            labelCol={{span: `${field.labelcol}`}}
                            wrapperCol={{span: `${field.fieldcol}`}}>
                            {dom}
                            </WeaFormItem>,
                        colSpan: 1,
                        hide: hide
                    });
                }
            });
            group.push(<WeaSearchGroup  className='hrm-center' hide={c.hide}
                        needTigger={true} title={c.title} showGroup={c.defaultshow} items={items} col={1}/>)
        });
        return group;
    }

    getTabChildren(){
        const {hrmAdd} = this.props;
        const {current, tableInfo1, tableInfo2, tabkey1,tabkey2} = hrmAdd;
        let tabChildren = [];
        let target;
        let tabkey;
        if (current === 1) {
            target = toJS(tableInfo1);
            tabkey = tabkey1;
        }
        if (current === 2) {
            target = toJS(tableInfo2);
            tabkey = tabkey2;
        }
        target && target.map((t,i)=>{
            if(tabkey==i){
                tabChildren.push(
                    <WeaTableEdit
                        // title={'列表信息'}
                        addFirstRow={true}
                        columns={t.tabinfo.columns}
                        datas={t.tabinfo.datas}
                        onChange={this.tableEditChange}
                    />
                );
            }
        })
        return tabChildren;
    }

    more(){

    }

    render() {
        const {hrmAdd} = this.props;
        const {visible, title, current, loading, conditionInfo1,conditionInfo2,conditionInfo3,tabInfo1,tabInfo2,tabkey1,tabkey2} = hrmAdd;
        let dialogHeight = window.innerHeight-250;
        if(dialogHeight>660)dialogHeight = 660;
        return <WeaDialog
                {...this.props}
                closable
                className="hrm-addfull"
                style={{width: 800, height: dialogHeight}}
                title = {title()}
                icon="icon-coms-hrm"
                iconBgcolor='#217346'
                buttons = {this.getBtns()}
                moreBtn={{datas: []}}
            >
                <Spin spinning={loading}>
                    <Steps current={current} className="step-wrapper">
                        <Step description={i18n.label.fillBasicInfo()} />
                        <Step description={i18n.label.fillPrivateInfo()} />
                        <Step description={i18n.label.fillWorkInfo()} />
                        <Step description={i18n.label.fillSysInfo()} />
                    </Steps>
                    <WeaNewScroll height={dialogHeight-120} ref="scrollBar">
                        <div className={`${current < 1? 'wea-show': 'wea-hide'}`}>
                            {this.getSearchs(0)}
                        </div>

                        <div className={`${current === 1? 'wea-show hrm-add-detial-tabs': 'wea-hide hrm-add-detial-tabs'}`}>
                            {!isEmpty(conditionInfo1)?
                            <div>
                                {this.getSearchs(1)}
                                {
                                    !isEmpty(tabInfo1) && <div>
                                        <WeaTab
                                        type='card'
                                        keyParam='key'
                                        datas={toJS(tabInfo1)}
                                        selectedKey={tabkey1}
                                        onChange={ v => {
                                            hrmAdd.updateTabkey(v);
                                        }}
                                        />
                                        {this.getTabChildren()}
                                        </div>
                                }
                            </div>:
                            <div>
                                <WeaAlertPage>
                                    <div style={{color : '#000'}}>
                                        {i18n.message.fillPrivateInfoAlarm()}
                                    </div>
                                </WeaAlertPage>
                            </div>
                            }
                        </div>

                        <div className={`${current === 2? 'wea-show hrm-add-detial-tabs': 'wea-hide hrm-add-detial-tabs'}`}>
                            {!isEmpty(conditionInfo2)?
                            <div>
                                {this.getSearchs(2)}
                                <WeaTab
                                    type='card'
                                    keyParam='key'
                                    datas={toJS(tabInfo2)}
                                    selectedKey={tabkey2}
                                    onChange={ v => {
                                        hrmAdd.updateTabkey(v);
                                    }}
                                />
                                {this.getTabChildren()}
                            </div>:
                            <div>
                                <WeaAlertPage>
                                    <div style={{color : '#000'}}>
                                    {i18n.message.fillWorkInfoAlarm()}
                                    </div>
                                </WeaAlertPage>
                            </div>
                            }
                        </div>

                        <div className={`${current === 3? 'wea-show': 'wea-hide'}`}>
                            {!isEmpty(conditionInfo3)?
                            <div>
                               {this.getSearchs(3)}
                            </div>:
                            <div>
                                <WeaAlertPage>
                                    <div style={{color : '#000'}}>
                                    {i18n.message.fillSysInfoAlarm()}
                                    </div>
                                </WeaAlertPage>
                            </div>
                            }
                        </div>
                    </WeaNewScroll>
                </Spin>

            </WeaDialog>
    }
}

export default Full


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/add/full.js